// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"HighConsumption_contentContainer__QPy0Z","translation":"HighConsumption_translation__3YRgI","options":"HighConsumption_options__Cj_Bj"};